export default "__VITE_PUBLIC_ASSET__ccc0e0c8__"